import { useCallback } from 'react'
import {
  SUGGESTION_TYPES,
  ToggleSuggestionsRequest,
} from '@trustero/trustero-api-web/lib/recommend/recommend_pb'
import { Empty } from 'google-protobuf/google/protobuf/empty_pb'
import { RecommendPromiseClient } from '@trustero/trustero-api-web/lib/recommend/recommend_grpc_web_pb'
import { useAuthorizedGrpcClient } from 'src/adapter'

export const useToggleSuggestions = ({
  controlId,
  suggType,
}: {
  controlId: string
  suggType?: SUGGESTION_TYPES
}): {
  restoreSuggestions: () => Promise<Empty>
  dismissSuggestion: () => Promise<Empty>
} => {
  const client = useAuthorizedGrpcClient(RecommendPromiseClient)

  const restoreSuggestions = useCallback((): Promise<Empty> => {
    return client.toggleSuggestions(
      new ToggleSuggestionsRequest()
        .setControlId(controlId)
        .setRestoreAll(true),
    )
  }, [client, controlId])

  const dismissSuggestion = useCallback((): Promise<Empty> => {
    return client.toggleSuggestions(
      new ToggleSuggestionsRequest()
        .setControlId(controlId)
        .setType(suggType || SUGGESTION_TYPES.UNKNOWN), // If no type is passed in, ensure API performs no update
    )
  }, [client, controlId, suggType])

  return {
    restoreSuggestions,
    dismissSuggestion,
  }
}
